/**
 * Shared building blocks for the Presentation mock-ups (`Presentation/*`
 * stories). The application shell, page headers, tab bar and small widgets are
 * defined once here and reused by the List view, Column view, Task sheet and
 * empty-page stories so the chrome stays identical and in one place.
 */
export * from "./tokens";
export { MainLogo } from "./MainLogo";
export { RoundAvatar } from "./RoundAvatar";
export { PresentationShell, StyledPagePaper } from "./PresentationShell";
export type { PresentationShellProps } from "./PresentationShell";
export { PageHeader, ProjectPageHeader, TabHeader } from "./headers";
export type {
  PageHeaderProps,
  ProjectPageHeaderProps,
  TabHeaderProps,
} from "./headers";
export { FloatingControls } from "./FloatingControls";
export {
  MessageDialog,
  DocLinkContext,
  messageComponents,
} from "./MessageDialog";
export type {
  MessageDialogProps,
  MessageDialogSize,
  OpenArticleHandler,
} from "./MessageDialog";
export { HelpAndSupportMenu } from "./HelpAndSupportMenu";
export type { HelpAndSupportMenuProps } from "./HelpAndSupportMenu";
export { LinkingCommandsButton } from "./LinkingCommandsButton";
export { LinkBranchOrPullRequestDialog } from "./LinkBranchOrPullRequestDialog";
export type { LinkBranchOrPullRequestDialogProps } from "./LinkBranchOrPullRequestDialog";
export {
  ConnectRepositoryDialog,
  RepositorySelect,
  buildRepoOptions,
  CONNECTIONS,
  PROJECT_REPOSITORIES,
  CONNECTABLE_REPOSITORIES,
} from "./ConnectRepositoryDialog";
export type {
  ConnectRepositoryDialogProps,
  RepositorySelectProps,
  Connection,
  ConnectionService,
  Repository,
} from "./ConnectRepositoryDialog";
export {
  WebhookLogsDialog,
  WEBHOOK_CONNECTIONS,
  WEBHOOK_REPOSITORIES,
} from "./WebhookLogsDialog";
export type {
  WebhookLogsDialogProps,
  WebhookConnection,
  WebhookRepository,
  WebhookLog,
} from "./WebhookLogsDialog";
export {
  SourceCodeSection,
  IssueRow,
  CodeRow,
  Spine,
  HistoryDialog,
  CompletedHeader,
} from "./SourceCodeSection";
export type {
  IssueEntry,
  CodeEntry,
  Stage,
  HistoryEvent,
  StageState,
  CodeStatus,
  SectionVariant,
} from "./SourceCodeSection";
export { SuggestSubtasksButton } from "./SuggestSubtasksButton";
export { TaskOptionsMenu, TaskListOptionsMenu } from "./TaskOptionsMenu";
export type {
  TaskOptionsMenuProps,
  TaskListOptionsMenuProps,
} from "./TaskOptionsMenu";
export { UserMenu } from "./UserMenu";
export type { UserMenuProps, UserMenuVariant } from "./UserMenu";
export { TwoFactorShield } from "./TwoFactorShield";
export type { TwoFactorShieldProps } from "./TwoFactorShield";
export { BackupCodesDialogs, CreateLoginCodeDialogs } from "./TwoFactorDialogs";
export type {
  BackupCodesDialogsProps,
  CreateLoginCodeDialogsProps,
} from "./TwoFactorDialogs";
export {
  SettingsHeader,
  SettingsContent,
  StyledSettingRow,
  RowText,
  SettingRow,
} from "./settings";
export type { SettingsHeaderProps, SettingRowProps } from "./settings";
export {
  FeatureAvailability,
  DEFAULT_FEATURE_AVAILABILITY,
} from "./FeatureAvailability";
export type {
  FeatureAvailabilityProps,
  AvailabilityRow,
  AvailabilityMark,
  AvailabilityStatus,
} from "./FeatureAvailability";
